export default class Config {
    public static readonly IS_DEBUG = false;
    /**
     * 中心服务器域名
     */
    public static readonly hubUrl = this.IS_DEBUG ? "https://localhost:18081/chat/" : "https://pig.k68.co:5001/chat/";
    /**
     * API接口
     */
    public static readonly API_HOST: string = this.IS_DEBUG ? "https://localhost:18081/api/" : "https://pig.k68.co:5001/api/";
}